import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"; // Import useLocation
import HeroPage from "./componants/HeroPage";
import ServicesPage from "./componants/ServicesPage";
import AboutPage from "./componants/AboutPage";
import TestimonialSlider from "./componants/TestimonialPage";
import AchievementsPage from "./componants/AchievementsPage";
import EbookPage from "./componants/EbookPage";
import PartnerPage from "./componants/PartnerPage";
import Navbar from "./componants/Navbar";
import ContactPage from "./componants/ContactPage";
import Footer from "./componants/Footer";
import FAQPage from "./componants/FAQPage";
import VirtualAssistantPage from "./pages/Virtual Staffing/Virtual-AssistantPage";
import BlogPage from "./componants/BlogPage";


import ScrollToTop from "./componants/ScrollToTop";
import GetStarted from "./componants/GetStarted";
import PlacementPage from "./pages/Career/PlacementPage";
import WebDevelopmentPage from "./pages/IT Services/WebDevelopment/Web_Development_In_Noida";
import WordPressServices from "./pages/IT Services/WebDevelopment/Wordpress_Development_In_Noida";
import ShopifyServices from "./pages/IT Services/WebDevelopment/Shopify_Development_In_Noida";
import FlutterAppDevelopment from "./pages/IT Services/AppDevelopment/Flutter_App_Development_In_Noida";
import AndroidAppDevelopmentPage from "./pages/IT Services/AppDevelopment/Android_App_Development_In_Noida";
import IosApp from "./pages/IT Services/AppDevelopment/Ios_App_Development_In_Noida";
import SearchEngine from "./pages/IT Services/DigitalMarketing/Search_Engine_Optimization_In_Noida";

import PPCServices from "./pages/IT Services/DigitalMarketing/Pay_Per_Click_In_Noida";
import StartupSolutions from "./pages/IT Services/Consultancy/Startup_Solution_In_Noida";
import BPOServices from "./pages/IT Services/Consultancy/BPO_Services_In_Noida";
import SellerServices from "./pages/IT Services/Consultancy/Seller_Services_In_Noida";
import PhpTrainingInNoida from "./pages/Course/Full-Stack/PHP_FullStack_Tranning_In_Noida";
import PythonFullStackTrainingInNoida from "./pages/Course/Full-Stack/Python_FullStack_Tranning_In_Noida";
import MernStackTrainingInNoida from "./pages/Course/Full-Stack/Mern_FullStack_Tranning_In_Noida";
import MernCertification from "./pages/Course/Programming_Language_In_Noida/Mern_Certification_In_Noida";
import PHPCertification from "./pages/Course/Programming_Language_In_Noida/PHP_Certification_In_Noida";
import PythonCourseInNoida from "./pages/Course/FrontEnd-BackEnd/Python_Course_In_Noida";
import PythonCertification from "./pages/Course/Programming_Language_In_Noida/Python_Certification_In_Noida";
import JavaCertification from "./pages/Course/Programming_Language_In_Noida/Java_Certification_In_Noida";
import JAVAFullStackInNoida from "./pages/Course/Full-Stack/Java_FullStack_Tranning_In_Noida";
import WebDesigningCourse from "./pages/Course/FrontEnd-BackEnd/WebDesigning_Course_In_Noida";
import AngularJsCourse from "./pages/Course/FrontEnd-BackEnd/AngularJs_Course_In_Noida";
import CCppCertification from "./pages/Course/Programming_Language_In_Noida/C++_Certification_In_Noida";
import ReactJsCourse from "./pages/Course/FrontEnd-BackEnd/ReactJs_Course_In_Noida";
import JAVACourse from "./pages/Course/FrontEnd-BackEnd/Java_Course_In_Noida";
import NodeJsCourse from "./pages/Course/FrontEnd-BackEnd/NodeJs_Course_In_Noida";
import SEOExpert from "./pages/Course/Digital_Marketing/SEO_Expert_In_Noida";
import PPCExpert from "./pages/Course/Digital_Marketing/PPC_Expert_In_Noida";
import SMMExpert from "./pages/Course/Digital_Marketing/SMM_Expert_In_Noida";
import GoogleAnalytics from "./pages/Course/Digital_Marketing/Google_Analytics_In_Noida";
import EmailMarketing from "./pages/Course/Digital_Marketing/Email_Marketing_In_Noida";
import VideoMarketing from "./pages/Course/Digital_Marketing/Video_Marketing_In_Noida";
import ITOutsources from "./pages/Virtual Staffing/IT_OutSource";
import DigitalMarketing from "./pages/Virtual Staffing/Digital_Marketing";
import MedicalBilling from "./pages/Virtual Staffing/Medical_Billing";
import FinanceAndAccountPage from "./pages/Virtual Staffing/Finanace_Account_In_Noida";
import LegalProcessPage from "./pages/Virtual Staffing/Legal_Process_In_Noida";
import SMMPage from "./pages/IT Services/DigitalMarketing/Social_Media_In_Noida";
import WebDevelopment from "./pages/Industrial_Tranning/Web_Development_In_Noida";
import FrontEndCertificationInNoida from "./pages/InternShip/FrontEnd_Certification_In_Noida";
import BackEndCertificationInNoida from "./pages/InternShip/BackEnd_Certification_In_Noida";
import FullStackDevelopmentInNoida from "./pages/InternShip/FullStack_Development_In_Noida";
import UIDesigningInNoida from "./pages/InternShip/UI_Designing_certification_In_Noida";
import DigitalMarketingInNoida from "./pages/InternShip/DigitalMarketing_Certification_In_Noida";
import DataScienceTraining from "./pages/Industrial_Tranning/DataScienceTraining";
import GraphicDesigningTraining from "./pages/Industrial_Tranning/Graphic_Designing_In_Noida";
import DatabaseManagementTraining from "./pages/Industrial_Tranning/DatabaseManagementTraining";
import PrivacyPolicy from "./componants/PrivacyPolicy";
import TermsAndConditions from "./componants/Term&Con";



// Optional: Create a Homepage that includes multiple sections
const HomePage = () => (
  <>
    <HeroPage />
    <ServicesPage />
    <TestimonialSlider />
    <AchievementsPage />
    <EbookPage />
    <PartnerPage />
  </>
);

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/About_Us" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/testimonials" element={<TestimonialSlider />} />
        <Route path="/achievements" element={<AchievementsPage />} />
        <Route path="/ebooks" element={<EbookPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FAQPage />}/>
        <Route path="/blog" element={<BlogPage />}/>
        {/* Add more routes as needed */}

        {/* Add other Vitrual-Staffing pages as needed */}
        <Route path="/Digital_Marketing_In_Noida" element={<DigitalMarketing />} />
        <Route path="/Medical_Billing_In_Noida" element={<MedicalBilling />} />
        <Route path="/Finanace_Account_In_Noida" element={<FinanceAndAccountPage />} />
        <Route path="/Virtual_Assistant_In_Noida" element={<VirtualAssistantPage />} />
        <Route path="/It_Outsourse_Tranning_In_Noida" element={<ITOutsources  />} />
        <Route path="/Legal_Proccess_In_Noida" element={<LegalProcessPage  />} />
        
         {/* Add other IT service pages as needed */}
         {/*Web Development*/}
        <Route path="/Custom_Web_Development_In_Noida" element={<WebDevelopmentPage />} />
        <Route path="/Wordpress_Web_Development_In_Noida" element={<WordPressServices />} />
        <Route path="/Shopify_Web_Development_In_Noida" element={<ShopifyServices />} />

         {/*App Development*/}
        <Route path="/Flutter_App_Development_In_Noida" element={<FlutterAppDevelopment />} />
        <Route path="/Android_App_Development_in_Noida" element={<AndroidAppDevelopmentPage />} />
        <Route path="/Ios-App-Development_In_Noida" element={<IosApp />} />

        {/* Digital Marketing*/}
        <Route path="/Search_Engine_Optimization_In_Noida" element={<SearchEngine />} />
        <Route path="/Social_Media_In_Noida" element={<SMMPage />} />
        <Route path="/Pay_Per_Click_In_Noida" element={<PPCServices />} />

       

        {/* Add other Career pages as needed */}
        <Route path="/Placement_In_Noida" element={<PlacementPage />} />
       

       

        {/* Add other Programming language pages as needed */}
        <Route path="/JAVA_Certification_In_Noida" element={<JavaCertification />} />
        <Route path="/Python_Certification_In_Noida" element={<PythonCertification />} />
        <Route path="/C/C++_Certification_In_Noida" element={<CCppCertification />} />
        <Route path="/Mern_Certification_In_Noida" element={<MernCertification />} />
        <Route path="/PHP_Certification_In_Noida" element={<PHPCertification />} />


        {/* Add other Full Strack pages as needed */}
        <Route path="/PHP_FullStack_Tranning_In_Noida" element={<PhpTrainingInNoida />} />
        <Route path="/Python_Fullstack_In_Noida" element={<PythonFullStackTrainingInNoida />} />
        <Route path="/Mern_FullStack__In_Noida" element={<MernStackTrainingInNoida/>} />
        <Route path="/JAVA_FullStack_In_Noida" element={<JAVAFullStackInNoida />} />

        {/* Add other FrondEnd/BackEnd pages as needed */}
        <Route path="/Python_Course_In_Noida" element={<PythonCourseInNoida />} />
        <Route path="/Web_Designing_Course_In_Noida" element={<WebDesigningCourse />} />
        <Route path="/Anguler_Js_Course_In_Noida" element={<AngularJsCourse />} />
        <Route path="/React_Js_Course_In_Noida" element={<ReactJsCourse />} />
        <Route path="/JAVA_Course_In_Noida" element={<JAVACourse />} />
        <Route path="/Node_Js_In_Noida" element={<NodeJsCourse />} />

        {/* Add other Digital Marketing pages as needed */}
        <Route path="/SEO_Expert_In_Noida" element={<SEOExpert />} />
        <Route path="/PPC_Expert_In_Noida" element={<PPCExpert />} />
        <Route path="/SMM/SMH_Expert_In_Noida" element={<SMMExpert />} />
       <Route path="/Google_Analytics_In_Noida" element={<GoogleAnalytics />} />
        <Route path="/Email_Marketing_In_Noida" element={<EmailMarketing />} />
        <Route path="/Video_Marketing_In_Noida" element={<VideoMarketing />} /> 

         {/* Add other InterShip pages as needed */}
         <Route path="/FrontEnd_Certification_In_Noida" element={<FrontEndCertificationInNoida />} />
          <Route path="/BackEnd_Certification_In_Noida" element={<BackEndCertificationInNoida />} />
          <Route path="/Full_Stack_Developer_In_Noida" element={<FullStackDevelopmentInNoida />} />
           <Route path="/UI/UX_Designing_Certification_In_Noida" element={<UIDesigningInNoida />} />
           <Route path="/Digital_marketing_Developer_In_Noida" element={<DigitalMarketingInNoida />} />

         {/* Add other Tranning Programmimg pages as needed */}
         <Route path="/Web_Development_In_Noida" element={<WebDevelopment />} />
          <Route path="/Data_Science_In_Noida" element={<DataScienceTraining />} />
           <Route path="/Graphic_Designing_In_Noida" element={<GraphicDesigningTraining />} />
          <Route path="/Database_Development_In_Noida" element={<DatabaseManagementTraining />} />


      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      </Routes>

      {/* Conditional rendering for GetStarted */}
      <GetStartedConditional />
      
      <Footer />
    </Router>
  );
};

// New component for conditional GetStarted rendering
const GetStartedConditional = () => {
  const location = useLocation();
  const hideOnPaths = ["/contact"]; // Add any other paths where you want to hide it

  // Check if the current path is in the hideOnPaths array
  const shouldHideGetStarted = hideOnPaths.includes(location.pathname);

  return shouldHideGetStarted ? null : <GetStarted />;
};

export default App;